import { useQuery } from "@tanstack/react-query";
import { dashboardQueryKeys } from "../query-keys";
import { fetchDashboardCatalog } from "../../../services/api/dashboard";
export function useDashboardCatalog() {
    var _a = useQuery({
        queryKey: dashboardQueryKeys.catalog(),
        queryFn: fetchDashboardCatalog,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return {
        catalog: data !== null && data !== void 0 ? data : null,
        loading: isLoading,
        error: error instanceof Error
            ? error.message
            : error
                ? "Não foi possível carregar o catálogo."
                : null,
    };
}
